const DEFAULT_ITEMS = [
  "SHOW UP SOLO",
  "LEAVE WITH A FAMILY",
  "AGES 18–45",
  "MAX 12 PER TRIP",
  "DATES & PRICING DROPPING SOON",
  "FLAGSHIP ESCAPES",
];

const EDITORIAL_ITEMS = [
  "ROAMIES",
  "SHOW UP SOLO",
  "LEAVE WITH A FAMILY",
  "SMALL CREWS",
  "BIG TRIPS",
  "NO STRANGERS",
];

export const Marquee = ({ dark = true, editorial = false }) => {
  if (editorial) {
    const row = [...EDITORIAL_ITEMS, ...EDITORIAL_ITEMS];
    return (
      <div
        data-testid="marquee-editorial"
        className="overflow-hidden py-10 sm:py-16 bg-cream border-y border-ink/10"
      >
        <div className="animate-marquee-slow flex whitespace-nowrap w-max items-center">
          {row.map((t, i) => (
            <span key={i} className="flex items-center font-display uppercase leading-none text-6xl sm:text-8xl">
              <span className={i % 2 === 0 ? "text-ink" : "text-outline-ink"}>{t}</span>
              <span className="text-flame text-3xl sm:text-5xl mx-8 sm:mx-12">✦</span>
            </span>
          ))}
        </div>
      </div>
    );
  }

  const row = [...DEFAULT_ITEMS, ...DEFAULT_ITEMS, ...DEFAULT_ITEMS];
  return (
    <div
      data-testid="marquee-strip"
      className={`overflow-hidden py-4 border-y ${dark ? "bg-ink text-cream border-ink" : "bg-flame text-white border-flame"}`}
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((t, i) => (
          <span key={i} className="font-display text-xl sm:text-2xl uppercase tracking-wide mx-6 flex items-center gap-6">
            {t} <span className={dark ? "text-flame" : "text-ink"}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
